<template>
  <PagesNews v-if="newsData" :object="newsData" />
  <div v-else class="error_not_found">
    <span class="code">404</span>
    <span>Not Found</span>
  </div>
</template>

<script setup>
import camelcaseKeys from 'camelcase-keys';
const { $useApi } = useNuxtApp();
const newsId = useRoute().params.id;
const headers = computed(() => useCustomRequestHeaders());

const { data: newsData } = await useFetch($useApi.news.getNews(newsId), {
  key: `news-${newsId}`,
  headers,
  transform: (response) => camelcaseKeys(response, { deep: true }),
});
</script>
